import baseService from './baseService'

export const userService = {
  login
}

function login (username, password, type) {
  return baseService.postRequest403Unhandled('users/authenticate', { username: username, password: password, type: type })
}
